// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { CmsImageSizesFragmentDoc } from '../../../cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from '../../../imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../../imageSize.fragment.generated';
export const CardCarouselCardFragmentDoc = `
    fragment cardCarouselCard on CardCarouselCard {
  backgroundColor
  image {
    ...cmsImageSizes
  }
  title
  description
}
    `;